import { useSelector } from 'react-redux'
import classes from './IconButton.module.sass'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'
import { IconType } from 'react-icons'

type Props = {
  onClick: () => void
  icon: string | IconType
  alt: string
  display: boolean
  disabled?: boolean
  small?: boolean
}

export const IconButton = ({ onClick, icon, alt, display, disabled, small }: Props) => {
  const dark = useSelector(selectDarkTheme)

  const isComponent = typeof icon !== 'string'
  const IconComponent = isComponent ? (icon as IconType) : null

  if (display)
    return (
      <button
        className={
          small && dark
            ? classes.ContainerSmallDark
            : dark
              ? classes.ContainerDark
              : small
                ? classes.ContainerSmall
                : classes.Container
        }
        onClick={(e) => {
          onClick()
          e.stopPropagation()
        }}
        disabled={disabled}
      >
        {isComponent && IconComponent ? (
          <IconComponent className={classes.Icon} title={alt} />
        ) : (
          <img src={icon as string} alt={alt} className={classes.Icon} />
        )}
      </button>
    )
  return <></>
}
